import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = {
    css: css`
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display:none;
                    position: fixed;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    background: ${getColor("common.background")({ theme })};
                    justify-content: center;
                    z-index: ${get(theme, "zIndex.stickyFooter")};
                `,
                css`
                    margin-left: 16px;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
}

checkoutReviewAndSubmitHeaderStyles.backButton = {
    variant: "secondary",
    mergeCss:true,
    css: css`
        background: #FFFFFF;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                    css`
                        flex-shrink: 1;
                    `,
                ],
                "max",
            )}
    `,
}

checkoutReviewAndSubmitHeaderStyles.placeOrderButton= {
    mergeCss: true,
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        span {
            color: #FFFFFF;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: unset;
                    `,
                ],
                "min",
            )}
    `,
}

checkoutReviewAndSubmitHeaderStyles.submitForApprovalButton = {
    mergeCss:true,
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                    css`
                        width: unset;
                    `,
                ],
                "min",
            )}
    `,
}